module.exports = __webpack_public_path__ + "static/media/herdy-standing.037781aa.svg";